// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

/* eslint-disable check-file/filename-blocklist */
import type { MutationUpdaterFn } from 'apollo-client';
import type { DataProxy } from 'apollo-cache';
import { type FetchResult } from 'apollo-link';

import type {
	ReactionsContentQuery,
	ReactionsContentQueryVariables,
	ReactionsContentQuery_content_nodes_contentReactionsSummary as ContentReactionsSummary,
} from './graphql/__types__/ReactionsContentQuery.ts';
import type {
	ConfluenceReactionsContentQuery,
	ConfluenceReactionsContentQuery_confluence_contentReactionsSummary_contentReactionsSummary as ConfluenceContentReactionsSummary,
	ConfluenceReactionsContentQueryVariables,
} from './graphql/__types__/ConfluenceReactionsContentQuery.ts';
import type {
	ReactionsCommentsQuery,
	ReactionsCommentsQueryVariables,
	ReactionsCommentsQuery_comments_nodes_reactionsSummary as CommentsReactionsSummary,
} from './graphql/__types__/ReactionsCommentsQuery.ts';
import type { ReactionsDeleteReactionMutation as ReactionsDeleteReactionMutation$data } from './__types__/ReactionsDeleteReactionMutation.ts';
import type { ReactionsConfluenceSaveReactionMutation as ReactionsConfluenceSaveReactionMutation$data } from './__types__/ReactionsConfluenceSaveReactionMutation.ts';
export type {
	ContainerType as GQLContainerType,
	GraphQLReactionContentType as GQLContentType,
} from './__types__/ReactionsConfluenceSaveReactionMutation.ts';

export enum ReactionLocation {
	PAGE = 'page',
	BLOGPOST = 'blogpost',
	PAGE_COMMENT = 'page-comment',
	INLINE_COMMENT = 'inline-comment',
	EDITOR_INLINE_COMMENT = 'editor-inline-comment',
	FEED_PAGE = 'feed-page',
	FEED_BLOGPOST = 'feed-blogpost',
	FEED_COMMENT = 'feed-comment',
	OBJECT_COMMENT_FOOTER_PAGE = 'object-comment-footer-page',
	OBJECT_COMMENT_FOOTER_BLOGPOST = 'object-comment-footer-blogpost',
}

export enum ReactionContainerType {
	PAGE = 'page',
	BLOGPOST = 'blogpost',
	SPACE = 'space',
}

export type ReactionResponse = {
	ari: string;
	containerAri: string;
	emojiId: string;
};

export type Reaction = {
	ari: string; // cloudId
	containerAri: string; // contentId
	emojiId: string;
	count: number;
	reacted: boolean;
	users?: ReactedUser[];
	optimisticallyUpdated?: boolean;
};

export type ReactedUser = {
	id: string;
	displayName: string;
};

export type ReactionsData =
	| ContentReactionsSummary
	| CommentsReactionsSummary
	| ConfluenceContentReactionsSummary
	| null;

export type QueryData =
	| ReactionsContentQuery
	| ReactionsCommentsQuery
	| ConfluenceReactionsContentQuery;
export type QueryVariables =
	| ReactionsContentQueryVariables
	| ReactionsCommentsQueryVariables
	| ConfluenceReactionsContentQueryVariables;

export type ReactedUsersMap = {
	[key: string]: ReactedUser[];
};

export type ReactionsMutationResultsData =
	| ReactionsConfluenceSaveReactionMutation$data
	| ReactionsDeleteReactionMutation$data;

export type ReactionsMutationResults = FetchResult<ReactionsMutationResultsData>;

export type ReactionMutationUpdateFn = (
	emojiId: string,
	actionType: 'add' | 'delete',
	contentId: string,
	containerId?: string,
	cache?: DataProxy,
	result?: ReactionsMutationResults,
	onCacheUpdateError?: (error: Error) => void,
) => MutationUpdaterFn<any> | void;
